import CONST from '../../../../../includes/primitives/_constant_trion'

export default {

  data: () => ({  

    HOST: CONST.HOST_NAME_RESOURCE + '/resources',
    
    canvasForm:     null,
    canvasTimeline: null,
    canvasSkyline:  null,
    canvasFront:    null,

    rawData:        null,
    skyData:        null,
    filteredData:   null,
    stageCodes:       [],

    Toggle:           'on',

    timeline: {},

    skyline: {
      refColumn     : 'ETA',
      width         : 20,
      height        : 4.2,
      gap           : 1,
      radius        : 0,
      tSize         : 10,
    },

  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

}